import { z } from 'zod';
/**
 * NR4: アセット参照（AssetRef 系）定義の SSoT モジュール。
 *
 * 旧来は 3 ファイル 4 箇所（minigameConfig.ts の `AssetRefSchema` / `AssetIdRefSchema`、
 * stepSchema.ts の `MediaRefSchema`（非 export const）、scenario.ts の
 * `RouteMapMediaRef`（TS interface））に同種の定義が分裂していた
 * （SPEC_FREEZE_MANIFEST §7-5）。2026-07-03 NR4 で本モジュールへ集約。
 * 仕様の正本ドキュメントは `docs/prod/specs/asset-reference-spec.md`。
 *
 * ポリシー（stepSchema.ts 旧 NOTE の引き継ぎ・asset-reference-spec.md §1-2）:
 * 本番方針では assetId（UUID）参照が正、URL 直保存は禁止。ただし既存データ
 * 互換のため schema レベルでは当面 URL も許容し、URL を弾く責任は Studio の
 * 保存/Publish ゲート（validateScenarioDraft.ts）が持つ。
 *
 * 凍結配下（schemaVersion 1）: 本モジュールは既存定義の「移設」であり、
 * parse 挙動・ワイヤ形状は一切変えない（同値性は assetRef.test.ts で固定）。
 */
/** assetId（UUID）。Worker `/api/v1/media/{assetId}` は UUID 必須（media.ts `assertUuid`）。 */
export const AssetIdSchema = z.string().uuid();
/** URL 形式の文字列（既存データ互換用。本番は assetId が正）。 */
export const AssetUrlSchema = z.string().url();
/**
 * メディア参照: assetId（UUID）または URL の union。
 * stepSchema.ts:11 から移設（元は非 export のモジュール内 const）。
 * URL 側（z.string().url()）は new URL() ベースの検証のため
 * `data:` / `blob:` スキームも通る（実挙動は assetRef.test.ts で固定）。
 */
export const MediaRefSchema = z.union([AssetIdSchema, AssetUrlSchema]);
/**
 * ミニゲーム config 等の緩いアセット参照（旧テンプレ 1-9 / 19 / 20 系）。
 * minigameConfig.ts:11-16 から移設。shape は凍結時のまま:
 * `assetId` は UUID 制約なしの素の string、`url` も任意文字列
 * （SPEC_FREEZE_MANIFEST §7-5 の現状維持。厳密化は別課題）。
 */
export const AssetRefSchema = z.object({
    assetId: z.string().optional(),
    url: z.string().optional(),
    alt: z.string().optional()
});
//# sourceMappingURL=assetRef.js.map